"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var _1 = require("../util/_");
var alert_content_1 = require("./alert-content");
var react_overlays_1 = require("../react-overlays");
var vdl_prefix_1 = require("../util/vdl-prefix");
var Alert = /** @class */function (_super) {
  __extends(Alert, _super);
  function Alert() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      isVisible: _this.props.defaultVisible
    };
    _this.isVisible = function () {
      return _this.state.isVisible;
    };
    _this.toggle = function () {
      _this.setState({
        isVisible: !_this.state.isVisible
      });
    };
    _this.show = function () {
      _this.setState({
        isVisible: true
      });
    };
    _this.hide = function () {
      _this.setState({
        isVisible: false
      });
    };
    _this.onAlertUnmount = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };
    return _this;
  }
  Alert.prototype.componentWillReceiveProps = function (nextProps) {
    var newState = {
      isVisible: this.state.isVisible
    };
    if (nextProps.isVisible !== undefined && nextProps.isVisible !== this.state.isVisible) {
      newState.isVisible = nextProps.isVisible;
      this.setState(newState);
    }
  };
  Alert.prototype.render = function () {
    var htmlProps = _1.omit(this.props, Object.keys(Alert.propTypes));
    var alertContentProps = _1.pick(this.props, Object.keys(alert_content_1.AlertContent.propTypes));
    var animate = this.props.animate;
    var alertContent = react_1.default.createElement(alert_content_1.AlertContent, __assign({}, alertContentProps, {
      key: "alert",
      onClose: this.hide,
      onUnmount: this.onAlertUnmount
    }));
    if (animate) {
      return react_1.default.createElement(react_overlays_1.Transition, __assign({}, htmlProps, {
        in: this.state.isVisible,
        timeout: 500,
        exitedClassName: vdl_prefix_1.vdlPrefix('alert--closed'),
        exitingClassName: vdl_prefix_1.vdlPrefix('alert--closing'),
        unmountOnExit: true
      }), alertContent);
    } else {
      return react_1.default.createElement("div", __assign({}, htmlProps), this.state.isVisible && alertContent);
    }
  };
  Alert.propTypes = Object.assign({
    defaultVisible: prop_types_1.default.bool,
    isVisible: prop_types_1.default.bool
  }, alert_content_1.AlertContent.propTypes);
  Alert.defaultProps = Object.assign({
    defaultVisible: true
  }, alert_content_1.AlertContent.defaultProps);
  return Alert;
}(react_1.default.Component);
exports.Alert = Alert;